export enum TargetingMediaTypeEnum {
    ONLINE = 'ONLINE',
    PRINT = 'PRINT',
    RADIO = 'RADIO',
    TELEVISION = 'TELEVISION',
}
